<template>
    <div id="GeGHSObj">
        <h2><span id="ghs_nummerSpan"><img :src="ghs_nummer.Piktogramm"></span><span id="ghs_bezeichnungSpan">
            <h3>{{ ghs_nummer.Name }}</h3>
            <h4>{{ ghs_nummer.GHS_Nummer }}</h4>
        </span></h2>
    </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
    name: "GeGHSObj",
    components: {},
    props: {
        ghs_nummer: Object,
    },
    data() {
        return {};
    },
    methods: {
        
    },
    created() {
        
    },
};
</script>

<style lang="scss">
#GeGHSObj {
    font-size: x-large;
    display: flex;
    justify-content: space-between;
    margin-left: 10%;
    margin-right: 10%;
    background-color: white;
    border: solid black 0.2rem;
    padding: 0.3rem;
    padding-left: 3rem;
    h2{
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    #ghs_nummerSpan{
        img{
            max-height: 10rem;
        }
    }
    
    #ghs_bezeichnungSpan{
        padding-left: 7rem;
        width: 100%;
        text-align: left; 
    }

    @media (max-width: 768px) {
        margin-left: 5%;
        margin-right: 5%;
        padding-left: 0rem;
        flex-direction: column;
        align-items: center;

        h2{
            margin-bottom: 0px;
            font-size: large;
            width: 100%;
            display: flex;
            justify-content:space-between
        }

        h3{
            margin: 0px;
            margin-bottom: 1rem;
        }

        h4{
            margin: 0px;
        }

        #ghs_nummerSpan{
            text-align: left;
            padding-left: 1rem;
            img{
                max-height: 4rem;
            }
        }

        #ghs_bezeichnungSpan{
            padding-left: 2rem;
            width: 100%;
            text-align: left;
        }

        .field {
            width: auto !important;
        }
    }
}
</style>
